<script>
  /**
   * 日付の入力を支援するコンポーネント
   *  +ｰ1日,+-1週間,+-1ヶ月 ボタンも実装
   */
  import { DateTime } from 'luxon'

  export let id
  export let label = ''
  export let value = DateTime.local().toFormat('yyyy-MM-dd') // 日付の初期値を設定

  // ID指定がない場合のデフォルトID設定
  $: assuredId = id ? `${id}DateInput` : `DateInput`

  // 選択された日付から曜日の日本語表記を作成
  $: weekday = DateTime.fromFormat(value, 'yyyy-MM-dd')
    .setLocale('ja')
    .toFormat('ccc')

  /**
   * 日付を加算する
   * @param duration luxonのduration
   */
  const plusDate = duration => () => {
    value = DateTime.fromFormat(value, 'yyyy-MM-dd')
      .plus(duration)
      .toFormat('yyyy-MM-dd')
  }

  // 日付移動ボタンの定義
  const dateShiftButtons = [
    {
      label: '<<',
      description: '1ヶ月前',
      onClick: plusDate({ months: -1 }),
    },
    {
      label: '<',
      description: '1週間前',
      onClick: plusDate({ weeks: -1 }),
    },
    {
      label: '-',
      description: '1日前',
      onClick: plusDate({ days: -1 }),
    },
    {
      label: '+',
      description: '1日後',
      onClick: plusDate({ days: 1 }),
    },
    {
      label: '>',
      description: '1週間後',
      onClick: plusDate({ weeks: 1 }),
    },
    {
      label: '>>',
      description: '1ヶ月後',
      onClick: plusDate({ months: 1 }),
    },
  ]
</script>

<div class="field">
  <label class="label" for={assuredId}>{label}</label>
  <div class="control">
    <!-- 編集用のinputタグ -->
    <input
      id={assuredId}
      data-testid={assuredId}
      type="date"
      class="input"
      bind:value
    />
    <!-- 曜日表示 -->
    <span class="weekday">{`(${weekday})`}</span>
  </div>
</div>

<div class="buttons are-small is-centered">
  {#each dateShiftButtons as entry, index}
    <button
      type="button"
      class="button"
      data-testid={`${id}DateButton${index}`}
      on:click={entry.onClick}
      >{entry.label}
    </button>
  {/each}
</div>

<style>
  .control {
    display: flex;
    align-items: center;
  }

  .input {
    width: auto;
    margin-bottom: 0px;
  }

  .weekday {
    padding: 5px;
  }
</style>
